let _get = null;

export default function ExchangeShopApi($get) {
  _get = $get;
}

function middleware(url, params, type = 'act') {
  if (_get) {
    return _get('/creator/', {
      [type]: url,
      ...params,
    });
  } else {
    return console.warn('function _get is undefined!');
  }
}

export const exhangeShopApi = {
  getGoods: params => middleware('get_goods', params),
  getGoodsDetails: params => middleware('get_goods_detail', params),
  buyGoods: params => middleware('buy_goods', params),
  getMailOrderList: params => middleware('get_mall_order_list', params),
  getMailOrderDetail: params => middleware('get_mall_order_detail', params),
  getJszxOverview: params => middleware('get_jszx_overview', params),
};
